<div class="st-drawer-wrapper create-budget-line-drawer flex flex-column">
  <a href=""></a>

  <!-- Header -->
  <div class="st-drawer-header show-border flex flex-column" style="align-items: flex-start; gap: 12px;">
    <div class="flex-center-between w-100">
      <span class="text-header-18 text-semibold">{{ isEditMode ? 'Editar' : 'Añadir' }} Línea de presupuesto</span>
      <app-st-icon class="text-header-16 cursor-pointer" (click)="close()" [name]="'close'" [bold]="true">
      </app-st-icon>
    </div>
    <!-- Badges de información -->
    <div class="info-badges flex gap-100">
      <span class="st-badget subtle-grey">
        <label>Presupuesto: {{ nzData.budget?.name || '-' }}</label>
      </span>
      <span class="st-badget subtle-grey">
        <label>Oportunidad: {{ nzData.budget?.lead?.name || '-' }}</label>
      </span>
    </div>
  </div>

  <div class="stepper" *ngIf="canCreateAssociatedCost || canCreateAssociatedSale || currentStep === 'cost' || currentStep === 'associatedSale'">
    <div class="stepper-item" [ngClass]="{ active: currentStep === 'sale' }" (click)="goToSaleStep()">
      <span>1. {{ budgetLineForm.value?.isCost ? 'Coste' : 'Venta' }}</span>
    </div>

    <app-st-icon name="keyboard_arrow_right"></app-st-icon>

    <div class="stepper-item"
      [ngClass]="{ active: currentStep === 'cost' || currentStep === 'associatedSale', disabled: !budgetLineForm.valid }"
      (click)="budgetLineForm.valid && (budgetLineForm.value?.isCost ? goToAssociatedSaleStep() : goToCostStep())">
      <span>2. {{ budgetLineForm.value?.isCost ? 'Venta asociada' : 'Coste asociado' }}</span>
    </div>
  </div>

  <!-- Content -->
  <div class="st-drawer-content">
    <form *ngIf="currentStep === 'sale'" [formGroup]="budgetLineForm" class="st-form" nz-form>
      <!-- Tipo: Unitario / Coste -->
      <div class="form-section">
        <span class="section-subtitle">Tipo</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <div style="margin-bottom: 8px;">

                  <nz-segmented [nzOptions]="['Total', 'Unitario']" [ngModel]="isUnitPriceSegmented"
                    (nzValueChange)="onUnitPriceSegmentedChange($event)"
                    [ngModelOptions]="{standalone: true}"></nz-segmented>
                </div>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <div>

                  <nz-segmented [nzOptions]="['Venta', 'Coste']" [ngModel]="isCostSegmented"
                    (nzValueChange)="onCostSegmentedChange($event)"
                    [ngModelOptions]="{standalone: true}"></nz-segmented>
                </div>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Información básica -->
      <!-- <div class="form-section">
        <span class="section-subtitle">Información básica</span>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Nombre / Descripción</nz-form-label>
          <nz-form-control [nzErrorTip]="'El nombre es requerido'">
            <textarea nzSize="large" nz-input formControlName="name"
              [nzAutosize]="{ minRows: 3, maxRows: 6 }"
              placeholder="Introduce la descripción de la línea de presupuesto..."></textarea>
          </nz-form-control>
        </nz-form-item>
      </div> -->

      <!-- Producto -->
      <div class="form-section">
        <span class="section-subtitle">Producto y Detalles</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Producto</nz-form-label>
                  <nz-form-control [nzErrorTip]="'El producto es requerido'">
                    <nz-select nzSize="large" formControlName="productId" nzPlaceHolder="Buscar producto..."
                      nzShowSearch>
                      <nz-option *ngFor="let product of filteredProducts" [nzValue]="product.id" [nzLabel]="product.name">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item *ngIf="budgetLineForm.value?.isCost">
                  <nz-form-label [nzSpan]="24" nzRequired>Ventas asociadas</nz-form-label>
                  <nz-form-control nzErrorTip="La venta asociada es requerida para líneas de coste">
                    <nz-select nzSize="large" formControlName="associatedSaleLineId"
                      nzPlaceHolder="Seleccione venta asociada" nzShowSearch nzAllowClear>
                      <nz-option *ngFor="let line of associatedSaleLines" [nzValue]="getAssociatedSaleOptionId(line)"
                        [nzLabel]="getLineLabel(line)">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Proveedor</nz-form-label>
                  <nz-form-control>
                    <app-avatar-select formControlName="supplierId" [options]="supplierList"
                      [createPartnerDrawerComponent]="ModifyPartnerDrawerComponent" [allowCreateNew]="true"
                      placeholder="Seleccione Proveedor" (partnerCreated)="onSupplierCreated($event)">
                    </app-avatar-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Descripción</nz-form-label>
                  <nz-form-control [nzErrorTip]="'El nombre es requerido'">
                    <textarea nzSize="large" nz-input formControlName="name"
                      [nzAutosize]="{ minRows: 4, maxRows: 8 }"
                      placeholder="Introduce la descripción de la línea..."></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Cantidad y unidad -->
      <div class="form-section">
        <span class="section-subtitle">Cantidad y unidad</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">
                    {{budgetLineForm.value?.isUnitPrice ? 'Cantidad estimada' : 'Cantidad'}}
                  </nz-form-label>
                  <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                    <input type="number" nzSize="large" nz-input formControlName="quantity" placeholder="0"
                      step="0.01" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Unidad</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="unitOfMeasureId" [options]="budgetUnitList"
                      placeholder="Seleccione Unidad" noneLabel="Ninguna" [noneValue]="0"
                      createPlaceholder="unidad..." [allowCreateNew]="true" masterType="unitOfMeasure"
                      [createDefaultValues]="{ unitOfMeasureCategoryId: getSelectedProductUnitCategoryId('budget') }"
                      (createdItem)="onUnitOfMeasureCreated($event, 'budget')">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Precio -->
      <div class="form-section">
        <span class="section-subtitle">Precio</span>

        <!-- Precio unitario -->
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Precio unitario</nz-form-label>
              <nz-form-control [nzErrorTip]="'El precio es requerido'">
                <input type="number" nzSize="large" nz-input formControlName="price" placeholder="0.00" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Moneda</nz-form-label>
              <nz-form-control [nzErrorTip]="'La moneda es requerida'">
                <nz-select nzSize="large" formControlName="currencyId" nzPlaceHolder="Seleccione Moneda">
                  <nz-option *ngFor="let currency of currencies" [nzValue]="currency.id"
                    [nzLabel]="currency.isoCode || currency.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- Descuento e Importe -->
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Descuento (%)</nz-form-label>
              <nz-form-control [nzErrorTip]="'El descuento debe estar entre 0 y 100'">
                <input type="number" nzSize="large" nz-input formControlName="discount" placeholder="0" min="0"
                  max="100" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Importe</nz-form-label>
              <nz-form-control>
                <div class="amount-display">
                  {{ budgetLineForm.get('amount')?.value | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <!-- Impuestos -->
      <div class="form-section">
        <span class="section-subtitle">Impuestos</span>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Impuestos</nz-form-label>
          <nz-form-control>
            <nz-select nzSize="large" formControlName="taxIds" [nzPlaceHolder]="budgetLineForm.value.productId && budgetLineForm.value.productId !== 0
                                ? 'Seleccione impuesto...'
                                : 'Seleccione un producto primero'"
              [nzDisabled]="!budgetLineForm.value.productId || budgetLineForm.value.productId === 0" nzShowSearch>
              <nz-option [nzValue]="null" nzLabel="Ninguno"></nz-option>
              <nz-option *ngFor="let tax of filteredTaxes" [nzValue]="tax.id"
                [nzLabel]="tax.name + ' (' + (tax.amount?.parsedValue || tax.amount || 0) + '%)'">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Localizaciones -->
      <div class="form-section">
        <span class="section-subtitle">Localizaciones</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Origen</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="sourceId" [options]="locationList"
                      placeholder="Seleccione origen" createPlaceholder="origen..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Destino</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="destinationId" [options]="locationList"
                      placeholder="Seleccione destino" createPlaceholder="destino..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

    </form>

    <form *ngIf="currentStep === 'cost'" [formGroup]="costLineForm" class="st-form" nz-form>
      <div class="form-section">
        <span class="section-subtitle">Tipo</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <div style="margin-bottom: 8px;">
                  <nz-segmented [nzOptions]="['Total', 'Unitario']" [ngModel]="costIsUnitPriceSegmented"
                    (nzValueChange)="onCostUnitPriceSegmentedChange($event)"
                    [ngModelOptions]="{standalone: true}"></nz-segmented>
                </div>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <div>
                  <nz-segmented [nzOptions]="['Venta', 'Coste']" [ngModel]="costIsCostSegmented"
                    [nzDisabled]="true" [ngModelOptions]="{standalone: true}"></nz-segmented>
                </div>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Coste asociado</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Producto</nz-form-label>
                  <nz-form-control [nzErrorTip]="'El producto es requerido'">
                    <nz-select nzSize="large" formControlName="productId" nzPlaceHolder="Buscar producto de coste..."
                      nzShowSearch>
                      <nz-option *ngFor="let product of costProductOptions" [nzValue]="product.id"
                        [nzLabel]="product.name">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Descripcion</nz-form-label>
                  <nz-form-control [nzErrorTip]="'El nombre es requerido'">
                    <textarea nzSize="large" nz-input formControlName="name"
                      [nzAutosize]="{ minRows: 3, maxRows: 6 }"
                      placeholder="Introduce la descripción del coste..."></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Proveedor</nz-form-label>
                  <nz-form-control>
                    <app-avatar-select formControlName="supplierId" [options]="supplierList"
                      [createPartnerDrawerComponent]="ModifyPartnerDrawerComponent" [allowCreateNew]="true"
                      placeholder="Seleccione Proveedor" (partnerCreated)="onSupplierCreated($event)">
                    </app-avatar-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Cantidad y unidad</span>
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Cantidad</nz-form-label>
              <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                <input type="number" nzSize="large" nz-input formControlName="quantity" placeholder="0" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Unidad</nz-form-label>
              <nz-form-control>
                <app-master-select formControlName="unitOfMeasureId" [options]="costUnitList"
                  placeholder="Seleccione Unidad" noneLabel="Ninguna" [noneValue]="0"
                  createPlaceholder="unidad..." [allowCreateNew]="true" masterType="unitOfMeasure"
                  [createDefaultValues]="{ unitOfMeasureCategoryId: getSelectedProductUnitCategoryId('cost') }"
                  (createdItem)="onUnitOfMeasureCreated($event, 'cost')">
                </app-master-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Precio</span>
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Precio de coste</nz-form-label>
              <nz-form-control [nzErrorTip]="'El precio es requerido'">
                <input type="number" nzSize="large" nz-input formControlName="price" placeholder="0.00" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Moneda</nz-form-label>
              <nz-form-control>
                <nz-select nzSize="large" formControlName="currencyId" nzPlaceHolder="Moneda derivada" [nzDisabled]="true">
                  <nz-option *ngFor="let currency of currencies" [nzValue]="currency.id"
                    [nzLabel]="currency.isoCode || currency.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Descuento (%)</nz-form-label>
              <nz-form-control [nzErrorTip]="'El descuento debe estar entre 0 y 100'">
                <input type="number" nzSize="large" nz-input formControlName="discount" placeholder="0" min="0"
                  max="100" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Importe</nz-form-label>
              <nz-form-control>
                <div class="amount-display">
                  {{ costLineForm.get('amount')?.value | currency: getCostCurrencyCode() : 'symbol' : '1.2-2' }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Impuestos</span>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Impuestos</nz-form-label>
          <nz-form-control>
            <nz-select nzSize="large" formControlName="taxIds" [nzPlaceHolder]="costLineForm.value.productId && costLineForm.value.productId !== 0
                                ? 'Seleccione impuesto...'
                                : 'Seleccione un producto primero'"
              [nzDisabled]="!costLineForm.value.productId || costLineForm.value.productId === 0" nzShowSearch>
              <nz-option [nzValue]="null" nzLabel="Ninguno"></nz-option>
              <nz-option *ngFor="let tax of costFilteredTaxes" [nzValue]="tax.id"
                [nzLabel]="tax.name + ' (' + (tax.amount?.parsedValue || tax.amount || 0) + '%)'">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Localizaciones</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Origen</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="sourceId" [options]="locationList"
                      placeholder="Seleccione origen" createPlaceholder="origen..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Destino</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="destinationId" [options]="locationList"
                      placeholder="Seleccione destino" createPlaceholder="destino..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form>

    <form *ngIf="currentStep === 'associatedSale'" [formGroup]="saleLineForm" class="st-form" nz-form>
      <div class="form-section">
        <span class="section-subtitle">Venta asociada</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <div style="margin-bottom: 8px;">
                  <nz-segmented [nzOptions]="['Total', 'Unitario']"
                    [ngModel]="saleLineForm.get('isUnitPrice')?.value ? 'Unitario' : 'Total'"
                    (nzValueChange)="saleLineForm.get('isUnitPrice')?.setValue($event === 'Unitario')"
                    [ngModelOptions]="{standalone: true}"></nz-segmented>
                </div>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <div>
                  <nz-segmented [nzOptions]="['Venta', 'Coste']" [ngModel]="'Venta'"
                    [nzDisabled]="true" [ngModelOptions]="{standalone: true}"></nz-segmented>
                </div>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Producto y Detalles</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Producto</nz-form-label>
                  <nz-form-control [nzErrorTip]="'El producto es requerido'">
                    <nz-select nzSize="large" formControlName="productId" nzPlaceHolder="Buscar producto de venta..."
                      nzShowSearch>
                      <nz-option *ngFor="let product of associatedSaleProductOptions" [nzValue]="product.id"
                        [nzLabel]="product.name">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" nzRequired>Descripcion</nz-form-label>
                  <nz-form-control [nzErrorTip]="'El nombre es requerido'">
                    <textarea nzSize="large" nz-input formControlName="name"
                      [nzAutosize]="{ minRows: 3, maxRows: 6 }"
                      placeholder="Introduce la descripción de la venta..."></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Cantidad y unidad</span>
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Cantidad</nz-form-label>
              <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                <input type="number" nzSize="large" nz-input formControlName="quantity" placeholder="0" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Unidad</nz-form-label>
              <nz-form-control>
                <app-master-select formControlName="unitOfMeasureId" [options]="saleUnitList"
                  placeholder="Seleccione Unidad" noneLabel="Ninguna" [noneValue]="0"
                  createPlaceholder="unidad..." [allowCreateNew]="true" masterType="unitOfMeasure"
                  [createDefaultValues]="{ unitOfMeasureCategoryId: getSelectedProductUnitCategoryId('sale') }"
                  (createdItem)="onUnitOfMeasureCreated($event, 'sale')">
                </app-master-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Precio</span>
        <div nz-row [nzGutter]="16">
          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Precio de venta</nz-form-label>
              <nz-form-control [nzErrorTip]="'El precio es requerido'">
                <input type="number" nzSize="large" nz-input formControlName="price" placeholder="0.00" step="0.01" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Moneda</nz-form-label>
              <nz-form-control [nzErrorTip]="'La moneda es requerida'">
                <nz-select nzSize="large" formControlName="currencyId" nzPlaceHolder="Seleccione Moneda">
                  <nz-option *ngFor="let currency of currencies" [nzValue]="currency.id"
                    [nzLabel]="currency.isoCode || currency.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="8">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Importe</nz-form-label>
              <nz-form-control>
                <div class="amount-display">
                  {{ saleLineForm.get('amount')?.value | currency: getSaleCurrencyCode() : 'symbol' : '1.2-2' }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-section">
        <span class="section-subtitle">Localizaciones</span>
        <nz-form-item>
          <nz-form-control>
            <div nz-row [nzGutter]="16">
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Origen</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="sourceId" [options]="locationList"
                      placeholder="Seleccione origen" createPlaceholder="origen..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col [nzXs]="24" [nzSm]="12">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Destino</nz-form-label>
                  <nz-form-control>
                    <app-master-select formControlName="destinationId" [options]="locationList"
                      placeholder="Seleccione destino" createPlaceholder="destino..."
                      [allowCreateNew]="true" masterType="location">
                    </app-master-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form>

    <!-- Subtotal (auto) -->
    <div class="subtotal-section">
      <div class="subtotal-display">
        <div class="subtotal-header">
          <span class="subtotal-label">Subtotal (auto)</span>
          <span class="subtotal-value" *ngIf="currentStep === 'sale'">{{ budgetLineForm.get('amount')?.value | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}</span>
          <span class="subtotal-value" *ngIf="currentStep === 'cost'">{{ costLineForm.get('amount')?.value | currency: getCostCurrencyCode() : 'symbol' : '1.2-2' }}</span>
          <span class="subtotal-value" *ngIf="currentStep === 'associatedSale'">{{ saleLineForm.get('amount')?.value | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}</span>
        </div>
        <div class="subtotal-divider"></div>
        <div class="subtotal-details" *ngIf="currentStep === 'sale'">
          <span class="subtotal-calculation">
            {{ budgetLineForm.get('quantity')?.value || 0 }} x {{ budgetLineForm.get('price')?.value || 0 | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}
          </span>
          <span class="subtotal-discount">
            Desc. {{ budgetLineForm.get('discount')?.value || 0 | number: '1.0-0' }}%
          </span>
        </div>
        <div class="subtotal-details" *ngIf="currentStep === 'cost'">
          <span class="subtotal-calculation">
            {{ costLineForm.get('quantity')?.value || 0 }} x {{ costLineForm.get('price')?.value || 0 | currency: getCostCurrencyCode() : 'symbol' : '1.2-2' }}
          </span>
          <span class="subtotal-discount">
            Desc. {{ costLineForm.get('discount')?.value || 0 | number: '1.0-0' }}%
          </span>
        </div>
        <div class="subtotal-details" *ngIf="currentStep === 'associatedSale'">
          <span class="subtotal-calculation">
            {{ saleLineForm.get('quantity')?.value || 0 }} x {{ saleLineForm.get('price')?.value || 0 | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}
          </span>
          <span class="subtotal-discount">
            Desc. {{ saleLineForm.get('discount')?.value || 0 | number: '1.0-0' }}%
          </span>
        </div>
        <div class="subtotal-details">
          <span class="subtotal-calculation">Total estimado</span>
          <span class="subtotal-discount" *ngIf="currentStep === 'sale'">
            {{ (budgetLineForm.get('quantity')?.value || 0) * (budgetLineForm.get('price')?.value || 0) | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}
          </span>
          <span class="subtotal-discount" *ngIf="currentStep === 'cost'">
            {{ (costLineForm.get('quantity')?.value || 0) * (costLineForm.get('price')?.value || 0) | currency: getCostCurrencyCode() : 'symbol' : '1.2-2' }}
          </span>
          <span class="subtotal-discount" *ngIf="currentStep === 'associatedSale'">
            {{ (saleLineForm.get('quantity')?.value || 0) * (saleLineForm.get('price')?.value || 0) | currency: getCurrencyCode() : 'symbol' : '1.2-2' }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="st-drawer-footer show-border">
    <button nz-button class="text-btn-14" nzType="text" nzShape="round" nzSize="large" (click)="discard()">
      <span>Descartar</span>
    </button>
    <div class="flex-center gap-100">
      <button nz-button nzType="default" nzShape="round" nzSize="large" (click)="goToSaleStep()"
        *ngIf="currentStep === 'cost' || currentStep === 'associatedSale'">
        <span>Volver</span>
      </button>
      <button nz-button nzType="default" nzShape="round" nzSize="large" [disabled]="!budgetLineForm.valid"
        (click)="goToCostStep()" *ngIf="canCreateAssociatedCost && currentStep === 'sale'">
        <span>Crear coste asociado</span>
        <app-st-icon class="sufix" [name]="'arrow_forward'" [bold]="true"></app-st-icon>
      </button>
      <button nz-button nzType="default" nzShape="round" nzSize="large"
        (click)="goToAssociatedSaleStep()" *ngIf="canCreateAssociatedSale && currentStep === 'sale'">
        <span>Crear venta asociada</span>
        <app-st-icon class="sufix" [name]="'arrow_forward'" [bold]="true"></app-st-icon>
      </button>
      <button nz-button nzType="default" nzShape="round" nzSize="large"
        [disabled]="currentStep === 'cost' ? !costLineForm.valid : (currentStep === 'associatedSale' ? !saleLineForm.valid : !budgetLineForm.valid)"
        [nzLoading]="saving" (click)="saveAndNew()" *ngIf="!isEditMode && ((!showCostStep && !showSaleStep) || currentStep === 'cost' || currentStep === 'associatedSale')">
        <span>Guardar y nuevo</span>
      </button>
      <button nz-button nzType="primary" nzShape="round" nzSize="large"
        [disabled]="currentStep === 'cost' ? !costLineForm.valid : (currentStep === 'associatedSale' ? !saleLineForm.valid : !budgetLineForm.valid)"
        *ngIf="(!showCostStep && !showSaleStep) || currentStep === 'cost' || currentStep === 'associatedSale'"
        [nzLoading]="saving" (click)="saveAndClose()">
        <span>Guardar y cerrar</span>
      </button>
    </div>
  </div>
</div>

<ng-template #notificationTmpl>
  <app-toast
    [notRef]="notRef!"
    [icon]="toastConfig.icon"
    [iconColor]="toastConfig.iconColor"
    [content]="toastConfig.content"
    [msg]="toastConfig.msg"
    [showUndo]="toastConfig.showUndo"
  ></app-toast>
</ng-template>
